"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsBase64Validator {
    isValid(input) {
        if (input) {
            return validatorJS.isBase64(input);
        }
        return false;
    }
}
exports.IsBase64Validator = IsBase64Validator;
//# sourceMappingURL=IsBase64Validator.js.map